var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z",
    fill: "#1DB954"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_27)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67592 4.01917C6.38016 4.01917 6.08935 4.09455 5.83093 4.23811C5.56779 4.37225 5.34568 4.57501 5.18816 4.82504C5.02837 5.07867 4.94115 5.37125 4.93599 5.67097L4.93591 5.67958V16.3396L4.93599 16.3482C4.94115 16.6479 5.02837 16.9405 5.18816 17.1941C5.34568 17.4442 5.56779 17.6469 5.83093 17.7811C6.08935 17.9246 6.38016 18 6.67592 18C6.97587 18 7.27073 17.9225 7.53188 17.7749C7.53763 17.7717 7.54331 17.7683 7.54892 17.7648L16.1787 12.4274C16.4404 12.2955 16.6613 12.0945 16.8175 11.846C16.9786 11.5895 17.0642 11.2926 17.0642 10.9896C17.0642 10.6866 16.9786 10.3897 16.8175 10.1331C16.6612 9.88438 16.4399 9.68328 16.1779 9.5514L7.5475 4.25347C7.54235 4.25031 7.53714 4.24724 7.53188 4.24427C7.27073 4.09671 6.97587 4.01917 6.67592 4.01917Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group 2.7769f2ef52b7da4cbd6aca245c4e463b.svg";
export { ForwardRef as ReactComponent };